import { hasPermission } from '@/hooks/useBackendMenu'
import { FormField } from 'global/components/Form'
import Dialog from 'global/guides/Dialog'
import { SubmitHandler } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import {
    Ajuste,
    ajustes,
    hasPermissionAjustes,
    ocorrenciaTipoToPermission,
} from 'service/api'
import { toast } from 'sonner'
import { z } from 'zod'

interface Reprovacao {
    tipo: Ajuste['tipoAjuste']
    id: number
}

export default function ReprovarVariosAjustesModal() {
    const navigate = useNavigate()
    let { ids }: { ids?: string | Reprovacao[] } = useParams()
    const { mutate } = ajustes.reprovacao.mutations.useUpdate({
        onSuccess: () => {
            ajustes.invalidateQueries()
        },
    })

    if (!ids) return navigate(-1) as never

    ids = ids
        .split(',')
        .map(id => ({
            tipo: (id.split('_')[0].charAt(0).toUpperCase() +
                id.split('_')[0].slice(1)) as Ajuste['tipoAjuste'],
            id: Number(id.split('_')[1]),
            hasPermission: hasPermission([
                'update',
                ocorrenciaTipoToPermission(id.split('_')[0] as any),
            ]),
        }))
        .filter(it => it.hasPermission)

    const handleSubmit: SubmitHandler<{
        justificativa: string
    }> = async data => {
        ;(ids as Reprovacao[])?.map(({ tipo, id }) => {
            mutate(
                { id, tipo, ...data },
                {
                    onError: e => {
                        toast.error(e.message)
                    },
                },
            )
        })
        toast.success('Ajustes reprovados com sucesso')
        navigate(-1)
    }

    return (
        <Dialog.Root
            open={hasPermissionAjustes()}
            onSubmit={handleSubmit}
            schema={z.object({
                motivo: z.string().trim().min(1, 'Campo obrigatório'),
            })}
        >
            <Dialog.Title>Reprovar ajustes</Dialog.Title>
            <Dialog.Content>
                <span className="text-base">
                    Você está prestes a reprovar {ids?.length} ajustes de ponto.
                    Tem certeza que deseja continuar?
                </span>
                <br />
                <FormField
                    name="motivo"
                    label="Justificativa"
                    multiline
                    required
                    max={150}
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton>
                    Confirmar
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
